<?xml version="1.0" encoding="UTF-8"?>
<!-- Generator: Adobe Illustrator 25.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 508.779 508.779" style="enable-background:new 0 0 508.779 508.779;" xml:space="preserve" width="512" height="512">
<g>
	<path d="M403.723,180.395v-31.061C403.723,66.859,336.864,0,254.389,0S105.056,66.859,105.056,149.333v31.061   c-39.236,20.023-63.952,60.334-64,104.384v106.667c0.071,64.772,52.561,117.263,117.333,117.333h192   c64.772-0.071,117.263-52.561,117.333-117.333V284.779C467.675,240.729,442.959,200.417,403.723,180.395z M254.389,64   c47.128,0,85.333,38.205,85.333,85.333v18.112H169.056v-18.112C169.056,102.205,207.261,64,254.389,64z M403.723,391.445   c0,29.455-23.878,53.333-53.333,53.333h-192c-29.455,0-53.333-23.878-53.333-53.333V284.779c0-29.455,23.878-53.333,53.333-53.333   h192c29.455,0,53.333,23.878,53.333,53.333V391.445z" fill="currentColor"/>
	<path d="M243.723,295.445h21.333c17.673,0,32,14.327,32,32l0,0c0,17.673-14.327,32-32,32h-21.333c-17.673,0-32-14.327-32-32l0,0   C211.723,309.772,226.05,295.445,243.723,295.445z" fill="currentColor"/>
</g>















</svg>
